import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import Prescription from './Prescription';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import { findOne } from '../../../actions/permissions';

let $ = window.jQuery;

export default class Index extends Component {
    state = {
        isSaving: false
    };

    handleOpenCreatePrescription = () => {
        if (! findOne(this.props.permissions, ['prescription.add', 'prescription.*'])) {
            this.props.showNotification('error', 'You dont have the correct permission to create prescriptions');

            return;
        }

        $('#prescriptionModal').modal('show');
    };

    render() {
        return (
            <div role="form" id="prescriptionPage">
                <NotificationSystem ref="notificationSystem" />

                <Prescription patientId={this.props.patientId} />

                <FloatingActionButton
                    title="Add New Prescription"
                    onClick={this.handleOpenCreatePrescription} />
            </div>
        )
    }

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Prescription/Index.js
 **/